import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { AvatarMultichain } from '@morpho-org/ui-v6/components/client/AvatarMultichain';
import { V1Badge } from '@morpho-org/ui-v6/server';
import { memo } from 'react';
import type { Warning } from '@/components/common/WarningIcon';
import { getVaultUrl } from '@/helpers/routing';
import { InternalLink } from '../InternalLink';
import { WarningIcon } from '../WarningIcon';
export interface VaultListVault {
  id: string;
  vaultName: string;
  address: Address;
  imageURI: string | null;
  chainId: number;
  vaultDeposit?: string | number | null;
  isVaultV2: boolean;
  warnings?: Warning[];
}
export interface VaultListProps {
  vaults: VaultListVault[];
  shouldOpenLinkInNewTab?: boolean;
}
const VaultList = t0 => {
  const $ = _c(7);
  const {
    vaults,
    shouldOpenLinkInNewTab
  } = t0;
  if (vaults.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== shouldOpenLinkInNewTab || $[1] !== vaults) {
    let t2;
    if ($[3] !== shouldOpenLinkInNewTab) {
      t2 = t3 => {
        const {
          id,
          vaultName,
          address: vaultAddress,
          imageURI,
          chainId,
          vaultDeposit,
          isVaultV2,
          warnings
        } = t3;
        const href = getVaultUrl({
          identifier: InterfaceChainUtils.getIdentifierById(chainId),
          vaultAddress,
          vaultName
        });
        const chain = {
          id: chainId,
          name: InterfaceChainUtils.getMetadata(chainId).chain.name
        };
        return <InternalLink key={id} href={href} shouldOpenLinkInNewTab={shouldOpenLinkInNewTab} onClick={_temp}><div className="gap-sm px-xs py-2xs hover:bg-background flex w-full cursor-pointer items-center justify-between rounded-lg"><div className="gap-xs flex items-center"><div className="gap-2xs flex items-center"><AvatarMultichain src={imageURI} chain={chain} size="small" /><span className="text-2xs text-foreground line-clamp-1">{vaultName}</span></div>{!isVaultV2 && <V1Badge tabIndex={-1} />}<WarningIcon warnings={warnings ?? []} iconSize={16} /></div>{vaultDeposit && <span className="text-2xs text-foreground">{vaultDeposit}</span>}</div></InternalLink>;
      };
      $[3] = shouldOpenLinkInNewTab;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = vaults.map(t2);
    $[0] = shouldOpenLinkInNewTab;
    $[1] = vaults;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="p-sm flex max-h-[200px] flex-col overflow-auto">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default memo(VaultList);
function _temp(e) {
  return e.stopPropagation();
}